function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 5,
  width: 18,
  height: 16,
  rx: 1,
  stroke: "#616161",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7 3V7",
  stroke: "#616161",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17 3V7",
  stroke: "#616161",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.04297 12.7568H8.81934C9.43457 12.7568 9.74219 12.4557 9.74219 11.8535C9.74219 11.6191 9.66895 11.4287 9.52246 11.2822C9.37598 11.1325 9.16927 11.0576 8.90234 11.0576C8.68424 11.0576 8.49382 11.1211 8.33105 11.248C8.17155 11.375 8.0918 11.5329 8.0918 11.7217H6.44629C6.44629 11.3473 6.55046 11.0137 6.75879 10.7207C6.96712 10.4277 7.25521 10.1999 7.62305 10.0371C7.99414 9.87109 8.40104 9.78809 8.84375 9.78809C9.63477 9.78809 10.2565 9.96875 10.709 10.3301C11.1615 10.6914 11.3877 11.1878 11.3877 11.8193C11.3877 12.1253 11.2933 12.415 11.1045 12.6885C10.9189 12.9587 10.6471 13.1784 10.2891 13.3477C10.6667 13.4844 10.9629 13.6927 11.1777 13.9727C11.3926 14.2493 11.5 14.5928 11.5 15.0029C11.5 15.6377 11.2559 16.1455 10.7676 16.5264C10.2793 16.9072 9.63802 17.0977 8.84375 17.0977C8.37826 17.0977 7.94531 17.0098 7.54492 16.834C7.14779 16.6549 6.84668 16.4092 6.6416 16.0967C6.43652 15.7809 6.33398 15.4229 6.33398 15.0225H7.98926C7.98926 15.2406 8.07715 15.4294 8.25293 15.5889C8.42871 15.7484 8.64518 15.8281 8.90234 15.8281C9.19206 15.8281 9.42318 15.7484 9.5957 15.5889C9.76823 15.4261 9.85449 15.2194 9.85449 14.9688C9.85449 14.6107 9.76497 14.3568 9.58594 14.207C9.4069 14.0573 9.15951 13.9824 8.84375 13.9824H8.04297V12.7568Z",
  fill: "#616161"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 14.0947C17.5 15.055 17.2835 15.7956 16.8506 16.3164C16.4209 16.8372 15.8138 17.0977 15.0293 17.0977C14.2383 17.0977 13.6263 16.8356 13.1934 16.3115C12.7604 15.7874 12.5439 15.0485 12.5439 14.0947V12.7959C12.5439 11.8356 12.7588 11.0951 13.1885 10.5742C13.6214 10.0534 14.2318 9.79297 15.0195 9.79297C15.8073 9.79297 16.4176 10.055 16.8506 10.5791C17.2835 11.1032 17.5 11.8438 17.5 12.8008V14.0947ZM15.8545 12.5859C15.8545 12.0749 15.7878 11.694 15.6543 11.4434C15.5208 11.1895 15.3092 11.0625 15.0195 11.0625C14.7363 11.0625 14.5296 11.1797 14.3994 11.4141C14.2725 11.6484 14.2041 12.0033 14.1943 12.4785V14.2949C14.1943 14.8255 14.2611 15.2145 14.3945 15.4619C14.528 15.7061 14.7396 15.8281 15.0293 15.8281C15.3092 15.8281 15.516 15.7093 15.6494 15.4717C15.7829 15.2308 15.8512 14.8548 15.8545 14.3438V12.5859Z",
  fill: "#616161"
});

var SvgIcCalendar = function SvgIcCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_calendar.53c4a9f0.svg";
export { ForwardRef as ReactComponent };